import { SxProps, Theme } from '@mui/material';

export const ClubDpPointsTitleSX: SxProps<Theme> = ({
	fontSize: 'var(--font-size-md)',
	color: '#2C2C2C',
	fontWeight: 800,
});

export const ClubDpPointsDescriptionSX: SxProps<Theme> = ({
	fontSize: 'var(--font-size-default)',
});

export const ClubDpPointsActionSX: SxProps<Theme> = ({
	fontSize: 'var(--font-size-default)',
	color: 'primary.main',
});

export const ClubDpPointsCardFrameSX = (isMobile: boolean): SxProps<Theme> => ({
	width: isMobile ? '100%' : '351px',
	height: isMobile ? '240px' : '225px',
	position: 'relative',
	textAlign: 'center',
	overflow: 'hidden',
	borderRadius: '10px',
	boxShadow: '0 16px 40px #7090B033',
	margin: 0,
	padding: 0,
});

export const ClubDpPointsCardImgSX: SxProps<Theme> = {
	objectFit: 'cover',
	width: '100%',
	height: '100%',
};

export const ClubDpPointsCardNumberSX: SxProps<Theme> = {
	position: 'absolute',
	width: '100%',
	top: '66%',
	height: '21px',
	zIndex: 1,
};

export const ClubDpPointsCardHolderFrameSX = (isMobile: boolean): SxProps<Theme> => ({
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-between',
	alignItems: 'center',
	border: '1px solid #E8E8E8',
	width: isMobile ? '100%' : '409px',
	paddingX: 3,
	paddingY: 1.5,
	backgroundColor: '#FFFFFF',
	borderRadius: '6px',
	order: { xs: 2, md: 1 },
});

export const ClubDpPointsCardLabelSX: SxProps<Theme> = ({
	fontSize: 'var(--font-size-small)',
	color: '#929292',
});

export const ClubDpPointsCardHolderSX: SxProps<Theme> = ({
	fontSize: 'var(--font-size-body)',
	color: '#333333',
	fontWeight: 600,
});

export const ClubDpPointsCardPointsFrameSX = (isMobile: boolean): SxProps<Theme> => ({
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	border: '1px solid #E8E8E8',
	width: isMobile ? '100%' : '409px',
	paddingX: 3,
	paddingY: 1.5,
	backgroundColor: '#FFFFFF',
	borderRadius: '6px',
	gap: 1,
	order: { xs: 1, md: 2 },
});

export const ClubDpPointsCardPointsSX: SxProps<Theme> = ({
	display: 'flex',
	alignItems: 'center',
	fontSize: 'var(--font-size-xl)',
	color: '#D20D48',
	fontWeight: 'bold',
	gap: 1,
});

export const ClubDpPointsCardPointsIconSX: SxProps<Theme> = ({
	fontSize: 'var(--font-size-xxl)',
});
